import { Component, OnInit, Input, Output, EventEmitter, ViewChild, HostListener, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AllReceivedMessageInputModel, AllReceivedMessageTimeline, PropertyTagSuggestion } from '../models/AllReceivedMessageInputModel';
import { AuthenticationService } from '../auth/authentication.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment'
import { DataTablesResponse } from '../../shared/models/datatables-response';
import { ValidationService } from '../providers/validation.service';
import { DataTableDirective } from 'angular-datatables';
import { CommonService } from '../providers/common.service';
import { MessageSearchInputModel, IMessageInput, MessageFollowInputModel } from '../models/MessageInputModel';
import { LoaderService } from '../providers/loader.service';
import { IMessageGroupMemberInputModel } from '../models/MessageGroupMemberInputModel';
import { MessageGroupCreateInputModel } from '../models/MessageGroupCreateInputModel';
import { IMessageGroupInputModel } from '../models/MessageGroupInputModel';
import { ToastService } from '../providers/toast.service';
import { IPropertyDetails } from '../models/propertydetails';
import { PropertyListingService } from '../providers/property-listing.service';
import { SharedService } from '../providers/shared.service';
import { UserManagerService } from '../providers/user-manager.service';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css']
})
export class MessagesComponent implements OnInit {

  constructor(public authService: AuthenticationService, private commonService: CommonService, private _userManagerService: UserManagerService,
    private Toast: ToastService, private loaderService: LoaderService, public Validation: ValidationService,
    private _propertyDetails: PropertyListingService, private modalService: BsModalService, private sharedService: SharedService) { }
  @Input() messages = [];
  @Output() openChatPopup = new EventEmitter();
  @Output() closeModalEvent = new EventEmitter();
  @Output() allMessageEvent = new EventEmitter();
  @Output() leaveGroupEvent = new EventEmitter();
  @Input() sendMessage = false;
  modalRef: BsModalRef;
  selectedExchangeId: number = 0;
  selectedGroupId: number;
  TimelineView: boolean = true;
  dtOptions = {};
  prevPage = '';
  activeTab: number;
  dt: any = {};
  searchVal: string = null;
  activeAccordian: string = null;
  currentPage: number = 1;
  GroupDataForSupress;
  messageListForSupress;
  totalMCount: number = 0;
  user: any;
  newGroup: boolean = false;
  newGroupName = null;
  propertyTagSuggestions: PropertyTagSuggestion[] = [];
  messageInput: MessageSearchInputModel = new MessageSearchInputModel();
  messageGroupMembers: IMessageGroupMemberInputModel[] = [];
  messageGroupDataLst = {} as MessageGroupCreateInputModel;
  messageGroupSingleData = {} as IMessageGroupInputModel;
  messageGroupMember = {} as IMessageGroupMemberInputModel;
  messageInputObject = {} as IMessageInput;
  messageGroups: IMessageGroupInputModel[] = [];
  groupMessageTimeLineData: AllReceivedMessageTimeline[] = [];
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  @Input() totalUnreadGroupMessages = 0;
  @Input() unreadMessages = 0;
  @Input() exchangeId = 0;
  totalUnreadIndividualMessages = 0;
  loggedinid: number;

  protected readonly BASE_URL: string = environment.base_url;
  allMessageList: AllReceivedMessageInputModel[] = [];
  filterMessageList: AllReceivedMessageInputModel[] = [];
  emptyMessageList: AllReceivedMessageInputModel[] = [];
  messageTimeLineData: AllReceivedMessageTimeline[] = [];
  selectedItem: AllReceivedMessageTimeline;
  selectedUsers: AllReceivedMessageTimeline[] = [];
  searchedUsers: AllReceivedMessageTimeline[] = [];
  filterByExchangeId: any = [];
  group = [];
  messageGroupId = 0;

  propertyId = 0;
  searchKeyword: string = "";
  searchGroupMember: string = "";
  @Input() property: IPropertyDetails;
  @Input() userid: number;
  ngOnInit() {
   
    this.sharedService.refreshMessageChange.subscribe(res => {
      if (res == true && res != undefined) {
        this.bindMessages(false, 0);
        this.sharedService.setrefreshMessage(false);
      }
    });
    this.loaderService.display(true);
    this.user = this.authService.user;
    this.loggedinid = this.user.Id;
    if (this.property != undefined && this.property != null && Object.keys(this.property).length != 0) {
      this.propertyId = this.property.Id;
      this.activeTab = 2;
      this.newGroup = false;
      this.searchKeyword = this.property.PropertySequenceId;
      this.messageInput.ObjectId = this.property.Id;
      this.messageInput.ExchangeId = this.exchangeId;
      this.bindMessages();
    }
    else if (this.exchangeId != null && this.exchangeId > 0) {

      this.searchKeyword = 'EX' + this.exchangeId;
      this.messageInput.ExchangeId = this.exchangeId;
      this.activeTab = 2;
      this.messageTimeLineData = [];
      this.currentPage = 1;
      this.newGroup = false;
      this.messageGroupMembers = [];
      this.bindMessages(false);
    }
    else if (this.userid != null && this.userid > 0) {
      this._userManagerService.GetUserDetailsForMessage(this.userid).subscribe(resp => {
        var name = resp;
        this.propertyId = 0;
        this.activeTab = 1;
        this.newGroup = false;
        this.searchKeyword = name['Name'];
        this.messageInput.ObjectId = this.userid;
        this.messageInput.ExchangeId = 0;
        this.onSearch();
        this.bindMessages();
      });
    }
    else {
      this.activeTab = 0;
      this.bindMessages();
    }

  }

  loadMessage(item: AllReceivedMessageTimeline) {
    if (item != undefined) {
      item.ReadMessage = true;
      item.TotalUnreadMessages = 0;
      item.ExchangeId = (item.ExchangeId == null || item.ExchangeId == 0) ? this.exchangeId : item.ExchangeId;
      this.openChatPopup.emit(item);
    }
  }
  createGroup(item) {
    if (item == null) {
      this.newGroup = !this.newGroup;
      this.messageGroupMembers = [];
      this.searchedUsers = [];
      this.newGroupName = null;
      this.searchKeyword = null;
      this.searchGroupMember = null;
      this.messageGroupId = 0;
    }
    else {
      var exchangeId = item.exchangeId == null ? 0 : item.exchangeId;
      var propertyId = item.ObjectId == null ? 0 : item.ObjectId;
      this.commonService.getAllGroupMembers(item.MessageGroupId, this.user.Id, exchangeId, propertyId).subscribe(resp => {
        this.messageGroupMembers = resp;
        this.newGroup = true;
        this.searchedUsers = [];
        this.searchGroupMember = null;
        this.newGroupName = item.DisplayName;
        this.messageGroupId = item.MessageGroupId;
      });
    }
  }
  closeModal() {
    this.property = {} as IPropertyDetails;
    this.searchKeyword = "";
    this.exchangeId = 0;
    this.propertyId = 0;
    this.closeModalEvent.emit();
    $('body').removeClass('chat-modal-open');
  }

  replaceHtml(text) {
    var html = text;
    var div = document.createElement("div");
    div.innerHTML = html;
    var result = div.textContent || div.innerText || "";
    return result.length > 25 ? result.substring(0, 25) + "..." : result;
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  bindMessages(addToList = true, newGroupId = 0) {
    // this.loaderService.display(true);
    this.user = this.authService.user;
    this.messageInput.UserId = this.user.Id;
    this.messageInput.UserRoleId = this.user.RoleId;
    this.messageInput.Search = !this.newGroup ? this.searchKeyword : this.searchGroupMember;
    this.messageInput.MessageTypeId = this.activeTab;
    this.messageInput.IsFav = this.activeTab == 3 ? true : false;

    this.messageInput.CurrentPage = this.currentPage;
    this.commonService.getAllMessageList(this.messageInput).subscribe(resp => {
      this.allMessageList = resp ? resp : [];;
      this.TimelineViewDataFilter(resp, addToList, newGroupId);
      this.loaderService.display(false);
    });
  }

  onSearch(addToList = false) {
    this.user = this.authService.user;
    this.messageInput.UserId = this.user.Id;
    this.messageInput.UserRoleId = this.user.RoleId;
    this.messageInput.Search = !this.newGroup ? this.searchKeyword : this.searchGroupMember;
    this.messageInput.CurrentPage = this.currentPage;
    this.messageInput.Count = 25;
    this.messageInput.MessageTypeId = this.activeTab;
    this.commonService.getAllUsersToMessage(this.messageInput).subscribe(resp => {
      if (!this.newGroup) {
        this.TimelineViewDataSearchedUsers(resp, addToList);
      }
      else {
        this.TimelineViewDataSearchedUsers(resp, addToList);
      }
      //this.loaderService.display(false);
    });
  }
  @HostListener('window:scroll', ['$event'])

  lastScroll = 0;
  enableScrollFn = true;
  scrollHandler($event: any) {
    const st = $event.srcElement.scrollTop;
    var totalRows = this.messageTimeLineData[0].TotalCount;
    if (st > this.lastScroll) {
      if ((st + $event.srcElement.clientHeight >= ($event.srcElement.scrollHeight - 350)) && (this.activeTab == 1 || (totalRows != this.messageTimeLineData.length))) {
        this.currentPage = this.currentPage + 1;
        this.messageInput.CurrentPage = this.currentPage;
        //this.enableScrollFn = false;
        if (this.activeTab != 1) {
          this.bindMessages(true);
        }
        else {
          this.onSearch(true);
        }

      }
    }

    this.lastScroll = st;
    //this.loaderService.display(false);
  }

  searchMessage() {
    if (this.activeTab != 1 && !this.newGroup) {
      this.currentPage = 1;
      this.messageTimeLineData = [];
      this.bindMessages(false);
    }
    else {
      this.currentPage = 1;
      this.onSearch();
    }
  }

  tabChange(tab: number) {
    this.exchangeId = 0;
    this.propertyId = 0;
    //this.messageInput.ObjectId = 0;
    this.currentPage = 1;
    this.messageInput.Count = 0;
    this.property = {} as IPropertyDetails;
    if (tab != 1) {
      this.activeTab = tab;
      this.messageTimeLineData = [];

      this.newGroup = false;
      this.messageGroupMembers = [];
      this.bindMessages(false);
    }
    else {
      this.onSearch();
      this.activeTab = tab;
    }
  }

  onUserSelect(event, item) {
    
    if (event.target.checked) {
      var isAllowed = true;
      if (this.authService.Admin() || this.authService.SuperAdmin()) {
        if (item.Role == "Data Entry Staff") {
          isAllowed = (this.messageGroupMembers.length == 0 || this.messageGroupMembers.filter(i => i.Role == "Data Entry Staff" || i.Role == "Admin" || i.Role == "Super Admin").length > 0) ? true : false;
        }
        else {
          isAllowed = (this.messageGroupMembers.length == 0 || this.messageGroupMembers.filter(i => i.Role == "Data Entry Staff").length == 0) ? true : false;
        }
      }
      if (isAllowed) {
        this.messageGroupMember = {} as IMessageGroupMemberInputModel;
        this.messageGroupMember.MemberId = item.UserId;
        this.messageGroupMember.Id = 0;
        this.messageGroupMember.GroupId = 0;
        this.messageGroupMember.Name = item.DisplayName;
        this.messageGroupMember.Role = item.Role;
        let isExist = this.messageGroupMembers.filter(i => i.MemberId == item.UserId).length;
        if (isExist == 0) {
          this.messageGroupMembers.push(this.messageGroupMember);
        }
        const index = this.messageTimeLineData.indexOf(item, 0);
        if (index > -1) {
          this.messageTimeLineData.splice(index, 1);
        }
      }
      else {
        $("#" + event.srcElement.id).prop("checked", false);
        this.Toast.addToast({ title: 'Warning', msg: "Can't create group with data entry staff and other users", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'warning' });
      }
    }
    else {
      let isExist = this.messageGroupMembers.filter(i => i.MemberId == item.UserId)[0];
      if (isExist != null && isExist != undefined) {
        const index = this.messageGroupMembers.indexOf(isExist, 0);
        this.messageGroupMembers.splice(index, 1);
      }
    }
  }


  removeUser(item) {
    const index = this.messageGroupMembers.indexOf(item, 0);
    if (index > -1) {
      this.messageGroupMembers.splice(index, 1);
    }
  }

  clearSearch() {
    this.searchGroupMember = "";
    this.searchMessage();
  }

  TimelineViewDataFilter(result: any, addToList = true, groupCreated = 0) {
    if (!addToList) {
      this.messageTimeLineData = [];
    }
    let data = result.map(data => data.ChatIdentifier);
    let dataNames = result.map(value => value.Name);
    data = data.filter(i => i != null);
    for (let i = 0; i < data.length; i++) {
      this.messageTimeLineData.push({
        GroupName: result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i])[0].ChatIdentifier + "_" + result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i])[0].Name.replace(/[^A-Z0-9]/ig, "_"),
        CreatedOn: result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i])[0].CreatedOn,
        DisplayName: result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i])[0].Name,
        Messages: result.filter(x => x.ExchangeIdHeader == data[i] && x.Name == dataNames[i]),
        MessageList: [],
        ObjectId: result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i])[0].ObjectId,
        TotalCount: result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i])[0].TotalCount,
        TotalMembers: result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i])[0].TotalMembers,
        ProfilePicture: (result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i])[0].ProfilePicture && !result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i])[0].IsGroup) ? result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i])[0].ProfilePicture : (result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i])[0].IsGroup ? "/../../../assets/img/group.png" : "/../../../assets/img/people.png"),
        PropertyName: null,
        ReadMessage: result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i])[0].ReadMessage,
        ExchangeId: result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i])[0].ExchangeId,
        MessageGroupId: result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i])[0].MessageGroupId,
        MessageDescription: result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i])[0].MessageDescription,
        CurrentMessage: null,
        showChild: false,
        UserId: result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i])[0].UserId,
        TotalMessages: result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i]).length,
        PropertyTagSuggestions: this.propertyTagSuggestions,
        TotalUnreadMessages: result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i])[0].TotalUnreadMessages,
        GroupMembers: [],
        ShowMembers: false,
        PhoneNumber: null,
        Role: null,
        Email: null,
        ChatIdentifier: data[i],
        IsGroup: result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i])[0].IsGroup,
        Suppress: result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i])[0].Suppress,
        IsSendByMe: result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i])[0].IsSendByMe,
        City: result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i])[0].City,
        State: result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i])[0].State,
        ExchangeOwner: result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i])[0].ExchangeOwner,
        Starred: result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i])[0].Starred,
        PropertyGuid: result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i])[0].PropertyGuid,
        GroupAdmin: result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i])[0].GroupAdmin,
        GroupId: result.filter(x => x.ChatIdentifier == data[i] && x.Name == dataNames[i])[0].GroupId
      });
      // this.loaderService.display(false);
    }

    this.allMessageEvent.emit(this.messageTimeLineData);
    setTimeout(() => {
      
      if (this.messageTimeLineData.length != 0 && this.propertyId > 0 && this.exchangeId == 0 && this.activeTab == 2) {

        this.loadMessage(this.messageTimeLineData.filter(i => i.DisplayName.startsWith(this.property.PropertySequenceId))[0]);

      }
      else if (this.messageTimeLineData.length != 0 && this.exchangeId > 0 && this.propertyId == 0 && this.activeTab == 2) {
        this.loadMessage(this.messageTimeLineData.filter(i => i.DisplayName == 'EX' + this.exchangeId)[0]);
      }
      else if (this.messageTimeLineData.length != 0 && this.exchangeId > 0 && this.propertyId > 0 && this.activeTab == 2) {
        var filter = 'EX' + this.exchangeId + " - " + this.property.Tenant + " (#" + this.property.PropertySequenceId + ")";
        this.loadMessage(this.messageTimeLineData.filter(i => i.DisplayName.startsWith(filter))[0]);
      }
      else if (this.messageTimeLineData.length != 0 && this.exchangeId == 0 && this.propertyId == 0 && this.userid > 0 && this.activeTab == 1) {
        this.loadMessage(this.messageTimeLineData.filter(i => i.UserId == this.userid)[0]);
      }
      if (groupCreated > 0) {
        this.loadMessage(this.messageTimeLineData.filter(i => i.MessageGroupId == groupCreated)[0]);
      }
    }, 1000);
  }

  showMembers(item) {

    var exchangeId = item.ExchangeId == null ? 0 : item.ExchangeId;
    var propertyId = item.ObjectId == null ? 0 : item.ObjectId;
    this.commonService.getAllGroupMembers(item.MessageGroupId, this.user.Id, exchangeId, propertyId).subscribe(resp => {
      item.GroupMembers = resp ? resp : [];
      item.ShowMembers = !item.ShowMembers;
      //if (item.Suppress != true) {
      //  this.messageGroupMember = {} as IMessageGroupMemberInputModel;
      //  this.messageGroupMember.MemberId = this.user.Id;
      //  this.messageGroupMember.Id = 1;
      //  this.messageGroupMember.Name = 'You';
      //  this.messageGroupMember.GroupId = 0;
      //  item.GroupMembers.push(this.messageGroupMember);
      //}
    });
  }

  leaveGroup(template: TemplateRef<any>, classes, item: AllReceivedMessageTimeline) {
    this.selectedItem = item;
    this.modalRef = this.modalService.show(template, { class: classes });
    }

  deleteGroupwarning(template: TemplateRef<any>, classes, item: AllReceivedMessageTimeline) {
        this.selectedItem = item;
        this.modalRef = this.modalService.show(template, { class: classes });
    }
    deleteGroup(item) {
        this.commonService.deleteGroup(item.MessageGroupId).subscribe(resp => {
            if (resp) {
                var index = this.messageTimeLineData.indexOf(item);
                this.messageTimeLineData.splice(index, 1);
              this.Toast.addToast({ title: 'Success', msg: 'Group Deleted Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
                this.leaveGroupEvent.emit(item);
                item.Suppress = true;
                item.TotalCount = item.TotalCount - 1;
            }
            else {
              this.Toast.addToast({ title: 'Error', msg: 'Unable to delete this group', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
            }
        });
    }

  followConversation(item: AllReceivedMessageTimeline, value = {} as MessageFollowInputModel) {
    value.IsFollow = !item.Starred;
    value.MessageGroupId = item.MessageGroupId > 0 ? item.MessageGroupId : null;
    value.LoggedInUserId = this.user.Id;
    value.UserId = item.UserId > 0 ? item.UserId : null;
    this.commonService.followConversation(value).subscribe(resp => {
      item.Starred = value.IsFollow;
      if (this.activeTab == 3) {
        var index = this.messageTimeLineData.indexOf(item);
        this.messageTimeLineData.splice(index, 1);
      }
    });
  }

  removeUserFromGroup(item, member, leaveGroup = false) {
    this.commonService.removeMemberFromGroup(item.MessageGroupId, leaveGroup ? this.user.Id : member.MemberId).subscribe(resp => {
      if (!leaveGroup) {
        const index = item.GroupMembers.indexOf(member, 0);
        if (index > -1) {
          item.GroupMembers.splice(index, 1);
        }
      }
      else {
        this.Toast.addToast({ title: 'Success', msg: 'Group Updated Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        this.leaveGroupEvent.emit(item);
        item.Suppress = true;
        item.TotalCount = item.TotalCount - 1;
      }
    });
  }

  TimelineViewDataSearchedUsers(result: any, addToList = false) {
    if (!addToList) {
      this.searchedUsers = [];
    }
    let data = result.map(data => data.UserId).filter(this.onlyUnique);
    data = data.filter(i => i != null);
    for (let i = 0; i < data.length; i++) {
      var checkUser = this.messageGroupMembers.findIndex(e => e.MemberId === data[i]);
        ////this.messageGroupMembers.indexOf(data[i], 0);
      if (checkUser <= -1) {
        this.searchedUsers.push({
          GroupName: result.filter(x => x.UserId == data[i])[0].UserId + "_" + (result.filter(x => x.UserId == data[i])[0].Name != null ? result.filter(x => x.UserId == data[i])[0].Name.replace(/[^A-Z0-9]/ig, "_") : 'user'),
          CreatedOn: result.filter(x => x.UserId == data[i])[0].CreatedOn,
          DisplayName: result.filter(x => x.UserId == data[i])[0].Name,
          Messages: result.filter(x => x.UserId == data[i]),
          MessageList: [],
          TotalMembers: result.filter(x => x.UserId == data[i])[0].TotalMembers,
          ObjectId: 0,
          TotalCount: result.filter(x => x.UserId == data[i])[0].TotalCount,
          PropertyName: null,
          ProfilePicture: result.filter(x => x.UserId == data[i])[0].ProfilePicture ? result.filter(x => x.UserId == data[i])[0].ProfilePicture : "/../../../assets/img/people.png",
          ReadMessage: result.filter(x => x.UserId == data[i])[0].ReadMessage,
          ExchangeId: result.filter(x => x.UserId == data[i])[0].ExchangeId,
          MessageGroupId: result.filter(x => x.UserId == data[i])[0].MessageGroupId,
          MessageDescription: result.filter(x => x.UserId == data[i])[0].MessageDescription,
          CurrentMessage: null,
          showChild: false,
          UserId: data[i],
          TotalMessages: result.filter(x => x.UserId == data[i]).length,
          PropertyTagSuggestions: this.propertyTagSuggestions,
          TotalUnreadMessages: result.filter(x => x.UserId == data[i])[0].TotalUnreadMessages,
          GroupMembers: [],
          ShowMembers: false,
          PhoneNumber: result.filter(x => x.UserId == data[i])[0].PhoneNumber,
          Role: result.filter(x => x.UserId == data[i])[0].Role,
          Email: result.filter(x => x.UserId == data[i])[0].Email,
          ChatIdentifier: 0,
          Suppress: result.filter(x => x.UserId == data[i])[0].Suppress,
          Starred: result.filter(x => x.UserId == data[i])[0].Starred,
          PropertyGuid: result.filter(x => x.UserId == data[i])[0].PropertyGuid,
          GroupAdmin: 0,
          GroupId: 0,

        });
      }

      // this.loaderService.display(false);
    }
    this.allMessageEvent.emit(this.searchedUsers);
    if (this.searchedUsers.length != 0 && this.activeAccordian == "") {
      this.searchedUsers[0].showChild = true;
    }


  }

  addNewGroup() {
    if (this.newGroupName != null && this.newGroupName != undefined && this.messageGroupMembers.length > 0) {
      this.loaderService.display(true);
      this.messageGroupMember = {} as IMessageGroupMemberInputModel;
      this.messageGroupMember.MemberId = this.user.Id;
      this.messageGroupMember.Id = 1;
      this.messageGroupMember.GroupId = 0;
      this.messageGroupMembers.push(this.messageGroupMember);

      this.messageGroupSingleData.Id = this.messageGroupId;
      this.messageGroupSingleData.GroupName = this.newGroupName;
      this.messageGroupSingleData.ObjectTypeId = 0;
      this.messageGroupSingleData.ObjectId = 0;
      this.messageGroupSingleData.ExchangeId = 0;
      this.messageGroupDataLst.LoggedInUserId = this.user.Id;
      this.messageGroupDataLst.MessageGroup = this.messageGroupSingleData;
      this.messageGroupDataLst.MessageGroupMembers = this.messageGroupMembers;
      this.messageGroupDataLst.MessageGroup.IsActiveId = 101;
      this.messageGroupDataLst.MessageGroup.IsGroupAdmin = true;

      this.commonService.SaveMessageGroupAndMembers(this.messageGroupDataLst).subscribe(responds => {
        if (this.messageGroupId == 0) {
          this.Toast.addToast({ title: 'Success', msg: 'Group Created Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        }
        else {
          this.Toast.addToast({ title: 'Success', msg: 'Group Updated Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });

        }
        this.newGroup = false;
        this.searchKeyword = "";

        this.bindMessages(false, responds);
        this.loaderService.display(false);
      });
    }
    else {
      if (this.messageGroupMembers.length > 0) {
        this.Toast.addToast({ title: 'Warning', msg: 'Group Name is Required', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'warning' });
      }
      else {
        this.Toast.addToast({ title: 'Warning', msg: 'Add members to create group', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'warning' });
      }
    }
  }
}
